import { motion } from "framer-motion";
import { EASE } from "@/components/Motion";

const brands = ["HONDA", "HERO", "TATA", "MAHINDRA", "APPLE", "SAMSUNG", "RELIANCE", "SONY"];

const Row = ({ items, reverse = false }) => (
  <div
    className="animate-marquee flex w-max"
    style={reverse ? { animationDirection: "reverse" } : undefined}
  >
    {[0, 1].map((dup) => (
      <div key={dup} className="flex shrink-0 items-center">
        {items.map((b, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`whitespace-nowrap px-10 text-4xl tracking-tight transition-colors duration-500 sm:text-6xl ${
                i % 2
                  ? "font-serif italic text-gold-grad"
                  : "font-bold text-neutral-800 hover:text-neutral-600"
              }`}
            >
              {b}
            </span>
            <span className="h-2.5 w-2.5 rotate-45 border border-gold/40" />
          </span>
        ))}
      </div>
    ))}
  </div>
);

export default function BrandPartners() {
  return (
    <section
      className="relative overflow-hidden border-y border-white/5 bg-[#08080B] py-20 sm:py-28"
      data-testid="brand-partners"
    >
      <div className="pointer-events-none absolute -top-24 left-1/4 h-64 w-64 rounded-full bg-gold/[0.05] blur-[120px]" />
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mx-auto max-w-3xl px-6 text-center"
      >
        <div className="font-mono text-[10px] uppercase tracking-[0.4em] text-gold/80">
          Our Official Brand Partners
        </div>
        <h2 className="mt-4 font-serif text-3xl italic text-neutral-50 sm:text-5xl">
          Trusted by the giants.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-neutral-500 sm:text-base">
          India's biggest names and the world's most loved brands run their growth on the same
          engine you are about to use.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1.2, ease: EASE, delay: 0.2 }}
        className="mt-14 space-y-8"
      >
        <Row items={brands} />
        <Row items={[...brands].reverse()} reverse />
      </motion.div>

      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink to-transparent sm:w-48" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink to-transparent sm:w-48" />
    </section>
  );
}
